import { NgModule } from '@angular/core';

import { BestQuotesComponent } from "app_locobook/shared/best-quotes/best-quotes.component";
import { CommonModule } from "@angular/common";
import { BookingModule } from "app_locobook/shared/booking/booking.module";
import { CardModule } from "libraries/ui_card/card.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { MapPipeModule } from "libraries/pipes/map/map-pipe.module";
import { HasOtherSegmentsPipe } from "app_locobook/shared/best-quotes/has-other-segments.pipe";
import { AirTripResourceModule } from "libraries/service/resources/airTrip/airTripResource.module";
import { AllSegmentDialogModule } from "app_locobook/shared/all-segment-dialog/all-segment-dialog.module";
import { FareFamilyBenchmarkModule } from "app_locobook/pages/quote-page/components/fare-family-benchmark/fare-family-benchmark.module";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    imports: [
        CommonModule,
        BookingModule,
        CardModule,
        BtnModule,
        MapPipeModule,
        AirTripResourceModule,
        AllSegmentDialogModule,
        FareFamilyBenchmarkModule,
        PermissionModule
    ],
    exports: [
        BestQuotesComponent,
        HasOtherSegmentsPipe
    ],
    declarations: [
        BestQuotesComponent,
        HasOtherSegmentsPipe,
    ],
    providers: [],
})
export class BestQuotesModule {
}
